import React, { useState } from 'react';
import { Button, Paper, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { requestIpConfirm } from '../../../actions/authentication';

function IpConfirmationForum({ classes, setIpConfirmation, setForum, ip, email}) {
  const dispatch = useDispatch();
  const [sendCode, setSendCode] = useState(true);
  const [code, setCode] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if(e == 'cancel')
      setIpConfirmation(false);
    else
    {
        
        const { hostname } = window.location;
        const subdomain = hostname.split('.')[0];
        dispatch(requestIpConfirm({ email, ip, hostname: subdomain })).then((res) => {
        setForum(false);
      });
    }
  };

  return (
              <Paper className={classes.paper} elevation={0}>
                  <form onSubmit={handleSubmit}>
                      <Typography component="h1" variant="h5" className={classes.twoFactorHeader}>
                          {'Security Confirmation'}
                      </Typography>
                      <p>Access from a new device or location detected.</p>
                      <p>For your security, please verify your identity with Email Authentication</p>
                      <Button fullWidth className={classes.submitButton} type="submit">
                        {'Send Verification Email'}
                      </Button>
                  </form>
              </Paper>
  );
}

export default IpConfirmationForum;
